import { cards } from '@/mocks/home';

export default function Cards() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">深度吃瓜</h2>
          <p className="text-sm text-foreground-600">为你深扒每个热门瓜背后的故事</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 6).map((item) => (
            <a key={item.id} href="#cards" className="group bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer">
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium bg-primary-500 text-white rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base text-foreground-900 mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {item.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {item.views}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
        {cards.length > 6 && (
          <div className="mt-5">
            <a
              key={cards[6].id}
              href="#cards"
              className="group block bg-background-100 rounded-xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="relative overflow-hidden sm:w-[320px] flex-shrink-0 aspect-[16/10] sm:aspect-auto">
                  <img
                    src={cards[6].image}
                    alt={cards[6].title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium bg-primary-500 text-white rounded-full whitespace-nowrap">
                    {cards[6].tag}
                  </span>
                </div>
                <div className="p-5 flex flex-col justify-center flex-1">
                  <h3 className="font-heading text-lg text-foreground-900 mb-2">{cards[6].title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">{cards[6].desc}</p>
                  <div className="flex items-center gap-4 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i> {cards[6].time}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {cards[6].views}
                    </span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        )}
      </div>
    </section>
  );
}